import React from 'react';
import { Pencil } from 'lucide-react';

const EditIcon = props => {
  const { className } = props;
  return <Pencil className={className} size={16} strokeWidth={1.25} role="none" />;
};

export default EditIcon;
